function setLocationHref(href) {
  window.location.href = href;
}

export { setLocationHref };
